import React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import { appLogo } from "../../assets";
import { t } from "i18next";

const Logo = () => {
  return (
    <Link style={{ textDecoration: "none" }} to={"/"}>
      <Box p={0} m={0} width={160}>
        <img src={appLogo.serviceProviderLogo} width={"80%"} height={"100%"} />
      </Box>
      <Typography
        sx={{ fontSize: "12px", color: "#7922d8", fontStyle: "italic" }}
        noWrap
        textTransform={"capitalize"}
      >
        {t("redefiningConvenienceAndEfficiency")}
      </Typography>
    </Link>
  );
};

export default Logo;
